import React, { useMemo, useState, useEffect } from "react";
import PropTypes from "prop-types";
// import CompanyCard, { ShimmerCompanyCard } from "CompanyCard";
import CompanyCard, { ShimmerCompanyCard } from "CompanyCard";

// import ShimmerCompanyCard from "CompanyCard/ShimmerCompanyCard";

const CompanyCardGrid = (props) => {
  let companies = props.companies;

  let useNamespaceTags = props.useNamespaceTags || false;

  const companiesGrid = companies.map((company, index) => {
    return (
      <div className="ps-flex-grid__item" key={index}>
        <CompanyCard
          company={company}
          enableLinkToProfile
          useNamespaceTags={useNamespaceTags}
          useCompanyCardAnchorLink={props.useCompanyCardAnchorLink}
        />
      </div>
    );
  });

  return (
    <div className="ps-flex-grid js-class-list ps-class-list">
      {companiesGrid}
    </div>
  );
};

export default CompanyCardGrid;

CompanyCardGrid.propTypes = {
  companies: PropTypes.array,
};
